(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('ScoreDialogController', ScoreDialogController);

    ScoreDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Score'];

    function ScoreDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Score) {
        var vm = this;

        vm.score = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.score.id !== null) {
                Score.update(vm.score, onSaveSuccess, onSaveError);
            } else {
                Score.save(vm.score, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:scoreUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
